import { render, staticRenderFns } from "./AddFeatures.vue?vue&type=template&id=136105d5"
import script from "./AddFeatures.vue?vue&type=script&lang=js"
export * from "./AddFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports